import setup from '@/setup'
import {util} from '@tubo/tubo-base'

util.title = function(title) {
  title = title || setup.title
  window.document.title = title
}

//dataUrl转blob
util.urlToBlob = function(url) {
  let arr = url.split(','),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], {type: mime});
}

// 如果是省级返回两位数, 市级返回4位数
util.dist6Trim = function(dist6) {
  if (!dist6)
    return null

  if (dist6.substr(2, 4) === '0000')
    return dist6.substr(0, 2)

  if (dist6.substr(4, 2) === '00')
    return dist6.substr(0, 4)

  return dist6
}


export default util
